import _classCallCheck from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseClient, SDK_VERSION, getCurrentHub, getEnvelopeEndpointWithUrlEncodedAuth } from '@sentry/core';
import { getGlobalObject, getEventDescription, logger, createClientReportEnvelope, dsnToString, serializeEnvelope } from '@sentry/utils';
import { eventFromException as _eventFromException, eventFromMessage as _eventFromMessage } from './eventbuilder.js';
import { BREADCRUMB_INTEGRATION_ID } from './integrations/breadcrumbs.js';
import { sendReport } from './transports/utils.js';
var globalObject = getGlobalObject();
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */

var BrowserClient = /*#__PURE__*/function (_BaseClient) {
  _inherits(BrowserClient, _BaseClient);

  var _super = _createSuper(BrowserClient);

  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  function BrowserClient(options) {
    var _this;

    _classCallCheck(this, BrowserClient);

    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [{
        name: 'npm:@sentry/browser',
        version: SDK_VERSION
      }],
      version: SDK_VERSION
    };
    _this = _super.call(this, options);

    if (options.sendClientReports && globalObject.document) {
      globalObject.document.addEventListener('visibilitychange', function () {
        if (globalObject.document.visibilityState === 'hidden') {
          _this._flushOutcomes();
        }
      });
    }

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BrowserClient, [{
    key: "eventFromException",
    value: function eventFromException(exception, hint) {
      return _eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "eventFromMessage",
    value: function eventFromMessage(message) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var hint = arguments.length > 2 ? arguments[2] : undefined;
      return _eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "sendEvent",
    value: function sendEvent(event, hint) {
      // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
      // activated its `sentry` option.
      // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
      // bundles, if it is not used by the SDK.
      // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
      // way for now.
      var breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID);

      if (breadcrumbIntegration && // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options && breadcrumbIntegration.options.sentry) {
        getCurrentHub().addBreadcrumb({
          category: "sentry.".concat(event.type === 'transaction' ? 'transaction' : 'event'),
          event_id: event.event_id,
          level: event.level,
          message: getEventDescription(event)
        }, {
          event: event
        });
      }

      _get(_getPrototypeOf(BrowserClient.prototype), "sendEvent", this).call(this, event, hint);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, scope) {
      event.platform = event.platform || 'javascript';
      return _get(_getPrototypeOf(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
    }
    /**
     * Sends client reports as an envelope.
     */

  }, {
    key: "_flushOutcomes",
    value: function _flushOutcomes() {
      var outcomes = this._clearOutcomes();

      if (outcomes.length === 0) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('No outcomes to send');
        return;
      }

      if (!this._dsn) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('No dsn provided, will not send outcomes');
        return;
      }

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Sending outcomes:', outcomes);
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options.tunnel);
      var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));

      try {
        sendReport(url, serializeEnvelope(envelope));
      } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error(e);
      }
    }
  }]);

  return BrowserClient;
}(BaseClient);

export { BrowserClient };